import React from 'react';

import { Form } from 'common/components';

const RoleActions = ({
  t,
  companyId,
  id,
  isActive,
  isDefault,
  canToggle,
  canUpdate,
  isLoading,
  handleToggle = () => {},
}) => {
  return (
    <div className="nowrap">
      {!isDefault && canUpdate && (
        <Form.Link
          to={`/companies/${companyId}/roles/${id}/edit`}
          className="btn btn-sm btn-primary"
        >
          {t('actions.edit')}
        </Form.Link>
      )}
    </div>
  );
};

export default RoleActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/components/RoleActions.js